import { useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Checkbox from '@mui/material/Checkbox';
import nwsFetch from './customFetch.js';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import {PasswordField, Submit} from './Fields.js';

export function APIToken(){

  const [token, setToken] = useState("");
	const [password, setPassword] = useState("");
	const [refresh, setRefresh] = useState(false);
	const [error, setError] = useState({});
  async function onSubmit(){
    let response = await nwsFetch(
      "/accounts/api/token/", {
        method: "POST",
        body: JSON.stringify({password: password, refresh: refresh}),
      },
      setError,
    );
    if(response.ok){
      const data = await response.json();
      if(data.token){
        setToken(data.token);
        setError("");
      }else{
        setError({"token": "You don't have an api token yet, please refresh"});
      }
    }
  }
  return (
		<Container maxWidth="sm">
			<Box component="form">
				<PasswordField setField={setPassword} error={error} id="password"/>
        <FormControlLabel
          checked={refresh}
          onChange={()=>setRefresh(!refresh)}
          control={<Checkbox/>}
          label="Refresh"
        />
				<Submit onSubmit={onSubmit} error={error} name="Obtain your api token"/>
			</Box>
      <TextField
        margin="normal"
        fullWidth
        disabled
        value={token}
        label="API token"
        error={error["token"]}
        helperText={error["token"]}
      />
		</Container>
  )
}
